/* @flow */
import CurrentUser from 'auth/CurrentUser';
import _ from 'lodash';
import errorLogger from 'utils/errorLogger';

const ZOPIM_JS = 'https://v2.zopim.com/?28wHYXfglWj5NGTN8wTxuTFkJztIk18f';

let loadId = null;
let isOnline = false;
let isWindowOpen = false;

function conditionButton() {
  const elements = document.getElementsByClassName('zopim');
  if (elements.length > 0) {
    const isLoggedIn = CurrentUser.isSignedIn();
    // The button is the first element (let's hope it stays that way...)
    elements[0].style.display = isOnline && !isWindowOpen && !isLoggedIn ? '' : 'none';
  }
}

export default class Zopim {
  static load() {
    if (window.$zopim) {
      // $FlowIssue
      return Promise.resolve(window.$zopim);
    }

    const $script = require('scriptjs');

    if (!loadId) {
      $script(ZOPIM_JS, (loadId = _.uniqueId('zopim')), () => {
        const zopim = window.$zopim;
        if (!zopim) {
          return;
        }

        const livechat = zopim.livechat;

        // Update isOnline state
        livechat.setOnStatus(status => {
          isOnline = status === 'online';
          conditionButton();
        });

        // Subscribe to user change to condition the button
        CurrentUser.addChangeListener(conditionButton);

        // Subscribe to show/hide to condition the button
        livechat.window.onShow(() => {
          isWindowOpen = true;
          conditionButton();
        });
        livechat.window.onHide(() => {
          isWindowOpen = false;
          conditionButton();
        });

        isWindowOpen = !!livechat.window.getDisplay();
        conditionButton();
      });
    }

    // $FlowIssue
    return new Promise(resolve => {
      $script.ready(loadId, () => {
        if (window.$zopim) {
          window.$zopim(() => resolve(window.$zopim));
        }
      });
    });
  }

  static show() {
    Zopim.load()
      .then(zopim => {
        zopim.livechat.window.show();
        isWindowOpen = true;
        conditionButton();
      })
      .catch(errorLogger('Zopim show failed'));
  }

  static hide() {
    Zopim.load()
      .then(zopim => {
        zopim.livechat.window.hide();
        isWindowOpen = false;
        conditionButton();
      })
      .catch(errorLogger('Zopim hide failed'));
  }

  // $FlowIssue
  static addStatusListener(listener) {
    Zopim.load()
      .then(zopim => {
        zopim.livechat.setOnStatus(listener);
      })
      .catch(errorLogger('Zopim addStatusListener failed'));
  }

  static getCurrentStatus() {
    return isOnline;
  }
}
